import { useCartLineItems, useCartShippingAddress } from '@ecomm/data-cart'
import { BATTERY_SKUS, airShippingStates } from '@ecomm/data-constants'

/**
 * Returns whether the disclaimer should be displayed.
 * If this is true, shipping options will not render until the user removes the product in question.
 */
export function useDisplayDisclaimer(): boolean {
  const lineItems = useCartLineItems()
  const shippingAddress = useCartShippingAddress()

  const hasBattery = lineItems.some(
    ({ sku, packageItems }) =>
      (sku && BATTERY_SKUS.includes(sku)) ||
      packageItems.some(p => BATTERY_SKUS.includes(p.sku))
  )
  const isAirShipping =
    !!shippingAddress?.state &&
    airShippingStates.includes(shippingAddress.state)

  return isAirShipping && hasBattery
}
